import React from "react";

const en_caixabank = {
  WELCOME_TO_NEMURU: "Welcome",
  WHAT_IS_NEMURU: "Where am I?",
  YOU_SHOULD_KNOW: "You should know that...",
  NEMURU_INTRO:
    "This technological platform allows you to apply for financing in 3 simple steps.",
  NEMURU_INTRO_SUB: "We work with the main financial entities.",
  CUSTOMER_SUPPORT_PHONE: "For any questions, contact us by calling $v1.",

  //EMBEDDED SIGNATURE
  CLICK_FINALIZE_AFTER_SIGNATURE:
    'While reviewing the documents, scroll to the bottom. When you have seen the message "This request has been signed correctly", click on "I have signed"',
  FINALIZE: "I have signed",

  //SLIDER
  PAPERLESS_EASY_AND_FAST: "Easy and fast",
  SPANISH_ACCOUNT_DETAIL:
    "You must have a Spanish bank account where you can directly debit your installments.",

  //DOCUMENTATION
  DOCS_PENDING_INFO:
    "If you are not yet a CaixaBank customer, upload the documents we will request you to provide.",
  UPLOAD_DOCS_NOW: "Continue",

  // GDPR
  TERMS_DISCLAIMER:
    "Hemos recibido la siguiente información de Facilitea los datos relativos a su pedido y el importe a financiar.",
  TERMS_AND_CONDITIONS: (
    <>
      <div style={{ paddingRight: "8px" }}>
        <h3 style={{ marginTop: "20px" }}>
          <strong>Información sobre el tratamiento de sus datos.</strong>
        </h3>
        <p>
          A continuación, le facilitamos la información básica sobre el
          tratamiento de sus datos. Puede consultar el detalle completo de cómo
          utilizaremos sus datos en nuestra Política de Privacidad, a la que
          puede acceder en cualquier momento desde{" "}
          <a
            href="https://www.caixabankpc.com/es/politica-de-privacidad"
            target="_blank"
          >
            https://www.caixabankpc.com/es/politica-de-privacidad
          </a>
        </p>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>El responsable del tratamiento</strong>
          </p>
          <p>
            Responsable del tratamiento: CaixaBank Payments & Consumer, E.F.C.,
            E.P., S.A., Sociedad Unipersonal («CaixaBank Payments & Consumer») –
            NIF: A-08980153 y domicilio en la avenida de Manoteras nº 20.
            Edificio Paris. 28050 Madrid (28050).
          </p>
          <p>
            Corresponsables de tratamiento: Además, para determinados
            tratamientos que le informamos en detalle en nuestra política,
            CaixaBank Payments & Consumer tratará conjuntamente sus datos con
            otras empresas, decidiendo de manera conjunta los objetivos (“para
            qué se usan los datos”) y los medios utilizados (“cómo se usan los
            datos”) siendo, por tanto, corresponsables de esos tratamientos.
          </p>
          <p>
            Los tratamientos para los cuales CaixaBank Payments & Consumer
            tratará conjuntamente sus datos con otras empresas se describen
            detalladamente en el epígrafe 6 de nuestra Política de Privacidad
            “Qué tratamientos realizamos con sus datos”.
          </p>
          <p>
            Además, encontrará la lista de las empresas que tratan sus datos,
            así como los aspectos esenciales de los acuerdos del tratamiento en
            corresponsabilidad en:{" "}
            <a href="www.caixabank.es/empresasgrupo" target="_blank">
              www.caixabank.es/empresasgrupo
            </a>
            .
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Finalidades del tratamiento</strong>
          </p>
          <p>
            Te pedimos tus datos de contacto, email y móvil para poder
            identificarte y ponernos en contacto contigo. Además, a través de
            estos medios podrás firmar tus contratos.
          </p>
          <p>
            A continuación, te informamos también de los tratamientos de tus
            datos para los que no nos hace falta pedirte el consentimiento.
            Tienes toda la información detallada en los enlaces:
          </p>
          <ul className="terms-and-conditions-ul">
            <li>
              Para la ejecución, formalización y mantenimiento de las relaciones
              contractuales.
            </li>
            <li>Para cumplir con nuestras obligaciones normativas.</li>
            <li>
              Para satisfacer intereses legítimos de CaixaBank Payments &
              Consumer:
            </li>
          </ul>
          <p>
            Puedes ejercer tu derecho de oposición a estos tratamientos en base
            a interés legítimo a través de este enlace:{" "}
            <a
              href="https://www.caixabankpc.com/es/politica-de-privacidad"
              target="_blank"
            >
              Ejercicio de derechos
            </a>
            .
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>
              Otra información acerca del tratamiento de los datos de tu
              solicitud
            </strong>
          </p>
          <p>
            Guardaremos la información que nos has facilitado durante un periodo
            de 10 días para que puedas continuar con el proceso en otro momento.
            A dicho efecto, te enviaremos notificaciones acerca de los procesos
            pendientes, por los medios de contacto que nos has facilitado.
          </p>
          <p>
            En el supuesto que no concluyas tu solicitud, tus datos dejarán de
            tratarse una vez transcurridos 10 días desde del inicio de la misma,
            y serán suprimidos.
          </p>
          <p>
            CaixaBank Payments & Consumer los conservará (tal como indica la
            normativa) durante el plazo de prescripción que resulte de
            aplicación, a los únicos efectos de cumplir las obligaciones legales
            que le sean requeridas, y para la formulación, ejercicio o defensa
            de reclamaciones.
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Derechos y reclamaciones</strong>
          </p>
          <p>
            En este enlace de{" "}
            <a
              href="https://www.caixabankpc.com/es/politica-de-privacidad"
              target="_blank"
            >
              Ejercicio de derechos
            </a>{" "}
            tienes toda la información para acceder, rectificar, y suprimir tus
            datos, así como ejercer otros derechos y también presentar una
            reclamación ante la Agencia Española de Protección de Datos.
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Información adicional</strong>
          </p>
          <p>
            Puede consultar la información adicional y detallada sobre
            Protección de Datos en nuestra Política de Privacidad:{" "}
            <a
              href="https://www.caixabankpc.com/es/politica-de-privacidad"
              target="_blank"
            >
              https://www.caixabankpc.com/es/politica-de-privacidad
            </a>
          </p>
        </div>
      </div>
    </>
  ),

  //SUA CONDITIONS
  SUA_TERMS_AND_CONDITIONS: (
    <>
      <div style={{ paddingRight: "8px" }}>
        <p>
          Para iniciar esta solicitud, es obligatorio que leas la información
          que te mostramos a continuación en la que se detalla cómo trataremos
          sus datos a la hora de evaluar tu solvencia y estudiar la concesión
          del préstamo.
        </p>
        <p>
          La persona o personas que suscriben este documento (en adelante el{" "}
          <strong>"Solicitante"</strong>), solicitan a CaixaBank Payments &
          Consumer, E.F.C., E.P., S.A.U. sociedad unipersonal (en adelante,{" "}
          <strong>“CaixaBank Payments & Consumer”</strong>), el estudio y, en su
          caso, la concesión de una financiación.
        </p>
        <p>A este efecto,</p>
        <ul className="terms-and-conditions-ul">
          <li>
            El Solicitante declara bajo su responsabilidad que conoce que la
            cumplimentación de los distintos apartados del procedimiento de
            solicitud es necesaria para poder darle curso, que los datos que
            facilita son ciertos, actualizados y corresponden a su persona y que
            las condiciones y garantías que se establezcan en el momento de la
            concesión podrán no ajustarse a las solicitadas. La base legal para
            el tratamiento de sus datos es su solicitud de financiación.
          </li>
          <li>
            CaixaBank Payments & Consumer informa al Solicitante que la
            normativa de aplicación sobre solvencia de las entidades de crédito
            (Directiva 2013/36/UE del Parlamento Europeo y del Consejo, de 26 de
            junio de 2013, relativa al acceso a la actividad de las entidades de
            crédito y a la supervisión prudencial de las entidades de crédito y
            las empresas de inversión, y correspondiente transposición de la
            norma comunitaria mediante Ley 10/2014, de 26 de junio, de
            ordenación, supervisión y solvencia de entidades de crédito) obliga
            a CaixaBank Payments & Consumer a evaluar la solvencia del
            Solicitante, de acuerdo con la información obtenida, así como la
            capacidad de cumplir con las obligaciones derivadas del producto
            solicitado, de acuerdo con la información obtenida, sus políticas y
            procedimientos.
            <p>
              A efectos del cumplimiento de dicha normativa, la evaluación de la
              solvencia y capacidad de cumplir con las obligaciones derivadas
              del producto solicitado, se realizará respecto de todos los datos
              del Solicitante obrantes en las siguientes entidades concedentes
              de crédito o gestoras de créditos, pertenecientes al grupo
              consolidado integrado por CaixaBank, S.A. (“
              <strong>CaixaBank</strong>”) y sus entidades dependientes a
              efectos de consolidación prudencial:
            </p>
            <p>
              CaixaBank, S.A.; Nuevo MicroBank, S.A.U.; CaixaBank Equipment
              finance, S.A.U.; Telefónica Consumer Finance, E.F.C., S.A.; Banco
              BPI, S.A.; Corporación Hipotecaria Mutual, E.F.C. S.A.;
              HipoteCaixa2, S.L.; CrediFimo, S.A.U. y Wivai Select Place S.A.U.
            </p>
          </li>
          <li>
            Si el Solicitante es un consumidor, CaixaBank Payments & Consumer
            estudiará su solicitud de acuerdo con la política de préstamos
            responsable. CaixaBank Payments & Consumer no adquiere compromiso
            alguno relativo a la concesión de la solicitud de la operación.{" "}
            <strong>
              CaixaBank Payments & Consumer podrá conceder la operación, en los
              términos propuestos u otros que considere más adecuados, o
              denegarla, de acuerdo con su política comercial y de riesgos
              vigente en cada momento.
            </strong>
          </li>
          <li>
            CaixaBank Payments & Consumer informa al Solicitante que puede
            contrastar si este está incluido en listas de personas o entidades
            específicamente designadas incluidas en leyes, regulaciones,
            directrices, resoluciones, programas o medidas restrictivas en
            materia de sanciones económico-financieras internacionales que
            CaixaBank Payments & Consumer aplique en cada momento, impuestas
            actualmente por las Naciones Unidas, Unión Europea, el Reino de
            España, Office of Financial Sanctions Implementation (OFSI) of Her
            Majesty’s Treasury (HMT)del Reino Unido y/o el U.S. Department of
            the Treasury’s Office of Foreign Assets Control (OFAC).
          </li>
          <li>
            Asimismo, CaixaBank Payments & Consumer informa al Solicitante que
            puede ceder sus datos a CONFIRMA SISTEMAS DE INFORMACIÓN, S.L. (“
            <strong>CONFIRMA</strong>”), con la finalidad de prevenir el fraude;
            las entidades adheridas al Reglamento que regula dicho tratamiento,
            todas ellas identificadas en www.confirmasistemas.es, son
            responsables del mismo y su encargada del tratamiento es CONFIRMA,
            ante la que los titulares de los datos pueden ejercer sus derechos
            de acceso, rectificación, oposición, supresión, limitación del
            tratamiento y portabilidad de datos, previstos en la Ley Orgánica
            3/2018, de 5 de diciembre, de Protección de Datos Personales y
            garantía de los derechos digitales mediante escrito dirigido a Avda.
            Industria, 18, de (28760) Tres Cantos (Madrid).
          </li>
          <li>
            Central de Información de Riesgos del Banco de España (CIR)
            <p>
              Con la presentación de la presente solicitud, CaixaBank Payments &
              Consumer queda habilitada para obtener de la CIR informes sobre
              los riesgos que el Solicitante pudiera tener registrados. Si
              finalmente se concede la operación de financiación, CaixaBank
              Payments & Consumer deberá declarar los datos necesarios para
              identificar a las personas con quienes se mantengan, directa o
              indirectamente, riesgos de crédito, así como las características
              de dichas personas y riesgos, incluyendo en particular, las que
              afecte al importe y recuperabilidad de estos.
            </p>
            <p>
              Si el titular del riesgo declarado a CIR considera que los datos
              declarados a su nombre son inexactos o incompletos podrá dirigirse
              directamente a la entidad declarante requiriendo su rectificación
              o cancelación o solicitar al Banco de España que les haga llegar
              su reclamación. Los titulares de datos de carácter personal pueden
              ejercer los derechos indicados en la normativa de protección de
              datos de acuerdo con los términos previstos legalmente, mediante
              escrito dirigido al Banco de España, sito en calle Alcalá, 48, de
              (28014) Madrid.
            </p>
          </li>
        </ul>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Consulta a Sistemas de información crediticia</strong>
          </p>
          <p>
            Con la presentación de la solicitud de financiación, CaixaBank
            Payments & Consumer queda habilitada para acceder a los datos
            contenidos en los siguientes Sistemas de información crediticia:
          </p>
          <p>
            <div>FICHERO ASNEF</div>
            <div>
              Asnef Equifax Servicios de Información sobre Solvencia y Crédito
            </div>
            <div>Ap. Correos 10546 28080 Madrid (sac@equifax.es)</div>
          </p>
          <p>
            <div>FICHERO BADEXCUG</div>
            <div>Ap. Correos 1188 28108 Alcobendas (badexcug@experian.com)</div>
          </p>
          <p>
            CaixaBank Payments & Consumer no basa de forma exclusiva la
            denegación de una solicitud de financiación en la consulta a
            Sistemas de información crediticia.
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Elaboración de perfiles y decisiones automatizadas</strong>
          </p>
          <p>
            Para estudiar la viabilidad de la solicitud, CaixaBank Payments &
            Consumer realizará tratamientos de los datos personales del
            Solicitante basados en modelos de scoring, y cualesquiera otros
            similares, consistentes en análisis estadísticos de variables
            sociodemográficas y económicas del Solicitante.
          </p>
          <p>
            En particular, CaixaBank Payments & Consumer elaborará un perfil del
            Solicitante que incluirá:
          </p>
          <ul className="ul-list-square">
            <li>El tipo de operación solicitada (cuota, plazo y finalidad).</li>
            <li>
              Información socioeconómica del Solicitante (residencia, edad y
              segmento comercial al que pertenece el Solicitante).
            </li>
            <li>
              La situación financiera global del Solicitante (saldos, ingresos y
              gastos).
            </li>
            <li>
              Información consultada en bases de datos externas relativos al
              incumplimiento de obligaciones dinerarias (Sistemas de información
              crediticia), así como datos de riesgo declarados por otras
              entidades financieras.
            </li>
          </ul>
          <p>
            CaixaBank Payments & Consumer atribuye un valor específico a cada
            uno de estos datos relativos al Solicitante y su solicitud, cuya
            suma es una puntuación equivalente a la probabilidad de morosidad o
            incumplimiento de las obligaciones dinerarias que este (el
            Solicitante) contraerá en el supuesto de formalización de la
            operación solicitada. La importancia de cada variable y su
            influencia en el resultado final se calcula de manera previa por
            CaixaBank Payments & Consumer a través de modelos matemáticos y se
            incluye en las políticas internas de riesgo de la entidad.
          </p>
          <p>
            En base a este resultado numérico, CaixaBank Payments & Consumer
            aceptará o rechazará su solicitud de manera automatizada en función
            del grado de riesgo que la entidad decida asumir en cada momento
            según sus políticas internas de riesgo.
          </p>
          <p>
            Se informa al Solicitante que puede ejercer su derecho a no ser
            objeto de una decisión basada únicamente en el tratamiento
            automatizado contactando directamente con CaixaBank Payments &
            Consumer mediante el envío de un correo electrónico a
            Revision.decisionautomatizada@caixabankpc.com, adjuntando copia del
            Documento Nacional de Identidad e identificando el establecimiento
            en el que ha realizado la solicitud de financiación.
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>
              Responsable del tratamiento y Delegado de Protección de Datos
            </strong>
          </p>
          <p>
            CaixaBank Payments & Consumer es un establecimiento financiero de
            crédito y entidad de pago filial de la entidad CaixaBank, S.A., con
            NIF A08980153 y domicilio en Avenida de Manoteras nº 20. Edificio
            París. 28050 Madrid.
          </p>
          <p>
            Se puede contactar con el Delegado de Protección de Datos en{" "}
            <a
              href="www.caixabank.com/delegadoprotecciondedatos"
              target="_blank"
            >
              www.caixabank.com/delegadoprotecciondedatos
            </a>
            .
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Finalidades del tratamiento</strong>
          </p>
          <p>
            Los datos personales del Solicitante y los que se obtengan para la
            tramitación de la presente solicitud, serán incluidos y tratados en
            ficheros de CaixaBank Payments & Consumer para analizar la solvencia
            del Solicitante y la viabilidad de la solicitud.
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Comunicaciones de datos</strong>
          </p>
          <p>
            Los datos podrán ser comunicados a autoridades y organismos
            públicos, para el cumplimiento de una obligación legal requerida,
            así como a proveedores de servicios y a terceros necesarios para la
            gestión y ejecución de su solicitud.
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Tratamiento de datos de terceros</strong>
          </p>
          <p>
            Los datos personales de terceros que CaixaBank Payments & Consumer
            reciba del Solicitante para la tramitación de la solicitud, serán
            tratados única y exclusivamente con dichos fines y no se comunicarán
            a terceros salvo en los casos en que la naturaleza del servicio
            implique necesariamente dicha comunicación, la cual se limitará a la
            finalidad expresada. CaixaBank Payments & Consumer mantendrá el
            secreto sobre los referidos datos y aplicará las medidas de
            seguridad legalmente exigibles.
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Período de conservación de los datos</strong>
          </p>
          <p>
            CaixaBank Payments & Consumer tratará los datos del Solicitante
            mientras permanezcan vigentes las relaciones contractuales o de
            negocio suscritas con él. En el supuesto de tener su autorización
            para el tratamiento de los datos con finalidades comerciales, los
            datos serán tratados hasta la revocación de dicha autorización o
            bien transcurridos doce (12) meses una vez finalizadas las
            relaciones contractuales o de negocio establecidas con CaixaBank
            Payments & Consumer.
          </p>
          <p>
            De acuerdo con la normativa, sus datos serán conservados a los
            únicos efectos de cumplir aquellas obligaciones legales impuestas a
            CaixaBank Payments & Consumer, y para la formulación, ejercicio o
            defensa de reclamaciones, durante el plazo de prescripción de las
            acciones derivadas de las relaciones contractuales o de negocio
            suscritas.
          </p>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>Ejercicio de derechos</strong>
          </p>
          <p>
            El Solicitante podrá ejercitar los derechos de acceso, revocación
            del consentimiento, rectificación, oposición, supresión, limitación
            y portabilidad de acuerdo con la Ley, mediante solicitud por
            cualquiera de los siguientes canales habilitados para ello:
          </p>
          <ul className="ul-list-square">
            <li>Las oficinas de CaixaBank</li>
            <li>
              Comunicación postal dirigida al Apartado de Correos nº 209 de
              Valencia (46080)
            </li>
            <li>
              A través de la dirección electrónica{" "}
              <a href="www.CaixaBank.com/ejerciciodederechos" target="_blank">
                www.CaixaBank.com/ejerciciodederechos
              </a>
            </li>
            <li>
              Mediante las opciones habilitadas a dicho efecto en su banca
              digital y en las aplicaciones móviles de CaixaBank y CaixaBank
              Payments & Consumer
            </li>
          </ul>
        </div>
        <div style={{ marginTop: 0 }}>
          <p style={{ marginTop: "20px" }}>
            <strong>
              Reclamaciones ante la Agencia Española de Protección de Datos
            </strong>
          </p>
          <p>
            Si el Solicitante no está conforme con el tratamiento de sus datos
            personales, puede acudir a la Agencia Española de Protección de
            Datos y presentar una reclamación a través de la siguiente URL:{" "}
            <a href="https://www.aepd.es/es" target="_blank">
              https://www.aepd.es/es
            </a>
            .
          </p>
        </div>
      </div>
    </>
  ),

  CHILD_SUPPORT_NUMBER: "Child support number",

  //INCOME_TYPE_TOGGLE
  ONLINE_BANK: "Express process",
  TRADITIONAL: "Standard process",
  GET_INFO_BANK:
    "Complete the process in a few steps by sharing your bank information",
  TRADITIONAL_PATH:
    "Follow the standard process by uploading the necessary information to confirm your identity and understand your financial situation",
  INVALID_CAIXABANK_IBAN: (
    <>
      {"Please enter a CaixaBank IBAN."}
      <br />
      {"XXXX 2100 XXXX XXXX XXXX XXXX"}
    </>
  ),
  CAIXABANK_IBAN_ONLY:
    "As a CaixaBank customer, please enter an IBAN corresponding to one of your accounts with CaixaBank",

  // DOCUMENTATION
  BANK_ACCOUNT_OWNERSHIP_DOCUMENTATION: "Proof of bank account ownership",

  //FLOW MESSAGES
  LOAN_ANALYSING:
    "We have submitted your request and will respond to you soon. Stay tuned!",
  LOAN_ANALYSING_DOCUMENTATION_NEEDED:
    "We have submitted your request. Upload the documentation now to receive the fastest response!",

  CAIXABANK_CARD_FOOTER: (
    <>
      IMPORTANT INFORMATION: You can consult more explanatory information
      regarding the main characteristics and risks of the financing product you
      are about to contract, as well as the prices usually applied to the most
      frequently provided banking services (
      <a
        href="https://www.caixabankpc.com/es/anejo1"
        target="_blank"
        rel="noopener noreferrer"
      >
        Annex 1 of Bank of Spain Circular 5/2012
      </a>
      ). Do you have any questions? Call us at 93 320 33 63.
    </>
  ),
};

export default en_caixabank;
